export function validMail(mail)
{
    return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(mail);
}

export function validString(string) {
    return !(string == null || string == "")
}

export function validName(string) {
    return string.length>1;
}

export function validPassword(pw) {
    return pw.length > 5;
}
